module.exports = __webpack_public_path__ + "documill-logo-32x32.svg?ca341d6834e18315e9a301e539550b19";